import { render, staticRenderFns } from "./DetailReception.vue?vue&type=template&id=03d8ed7a&scoped=true"
import script from "./DetailReception.vue?vue&type=script&lang=js"
export * from "./DetailReception.vue?vue&type=script&lang=js"
import style0 from "./DetailReception.vue?vue&type=style&index=0&id=03d8ed7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d8ed7a",
  null
  
)

export default component.exports